module.exports = __webpack_public_path__ + "static/media/following_yellow.339711d3.png";